import React from 'react';
import { Button, Spin, Table } from 'antd';
import { TextField } from 'redux-form-antd';
import { Field } from 'redux-form';
import styled from 'styled-components';
import BigQueryModal from '../BigQueryModal';
import InlineMessage from '../../atoms/InlineMessage';

const TheError = errorMessage => [
  <strong>Error</strong>,
  <br />,
  typeof errorMessage === 'string' ? errorMessage : 'Could not load audiences.',
];

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};
const StyledTable = styled(Table)`
  tbody {
    tr:not(:first-child) {
      cursor: pointer;
    }
  }
`;

const AudienceForecastTab = ({
  setEditRecord,
  audienceList,
  show,
  isPolling,
  handleSubmit,
  submitting,
  errorMessage,
  hide,
  visible,
  fetching,
  selectedAudience,
  fetchingAudience,
  failed,
}) => (
  <div>
    <BigQueryModal
      loading={fetchingAudience}
      title={selectedAudience.id ? 'Update Audience' : 'New Audience'}
      submitText={selectedAudience.id ? 'Update' : 'Create'}
      onHideBigQuery={handleSubmit}
      loadingAudienceQuery={submitting}
      visible={visible}
      hideModal={hide}
    >
      <Field
        {...formItemLayout}
        label="Audience Name"
        name="name"
        component={TextField}
        rows={15}
      />
    </BigQueryModal>
    {failed && <InlineMessage type="error" message={TheError(errorMessage)} />}
    {!failed && (
      <Spin spinning={!isPolling && fetching}>
        <p>
          <Button onClick={show}>+ Add new audience</Button>
        </p>
        <StyledTable
          locale={{
            emptyText: 'Create a targeted revision to find device reach',
          }}
          dataSource={audienceList}
          onRow={record => ({
            onClick: record.onClick !== undefined ? record.onClick : () => setEditRecord(record),
          })}
          columns={[
            {
              title: 'Name',
              render: (name, record) =>
                record.onClick === null ? name : <a href="#edit">{name}</a>,
              dataIndex: 'name',
            },
            {
              title: 'Devices',
              dataIndex: 'device_count',
              render: n => (n ? n.toLocaleString() : ''),
            },
          ]}
        />
      </Spin>
    )}
  </div>
);

export default AudienceForecastTab;
